import eventService from '@/api/event'
import errorhandler from '@/utils/errorhandler.js'

export default {
  namespaced: true,
  actions: {
    async checkout({ dispatch }, roomEvent) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await eventService.checkout(roomEvent.roomId, roomEvent.eventId, roomEvent.start, roomEvent.finish)
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    }
  }
}
